var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dropdown-demo"}},[_c('dropdown-default'),_c('dropdown-color'),_c('dropdown-group-option'),_c('dropdown-custom-content'),_c('dropdown-button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }